import { render } from "./KhmerForceSecurity.vue?vue&type=template&id=16c64445"
import script from "./KhmerForceSecurity.vue?vue&type=script&lang=js"
export * from "./KhmerForceSecurity.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__